export const SET_INIT_STATE = 'SET_INIT_STATE';
export const SET_EXERCISE_SUBMIT_TYPE = 'SET_EXERCISE_SUBMIT_TYPE';
export const SET_EXERCISE_SUBMIT_RESULT = 'SET_EXERCISE_SUBMIT_RESULT';
export const SET_TOGGLE_SHOW_SUBMIT_RESULT = 'SET_TOGGLE_SHOW_SUBMIT_RESULT';
export const SET_CURRENT_STEP = 'SET_CURRENT_STEP';
